import { render } from "./DealProductsWrapper.vue?vue&type=template&id=34acc656&ts=true"
import script from "./DealProductsWrapper.vue?vue&type=script&lang=ts"
export * from "./DealProductsWrapper.vue?vue&type=script&lang=ts"

import "./DealProductsWrapper.vue?vue&type=style&index=0&id=34acc656&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__